import Excel from 'exceljs';
import zipObject from 'lodash.zipobject';

const HEADER_ROW_INDEX = 1;
const ACCOUNT_DATA_COLUMN_NAMES = ['orgId', 'accountId', 'jurisdictionId', 'begEndFlag', 'amount'];

const isRowEmpty = row => Object.values(row).every(cell => !cell && cell !== 0);

export const parseGenericAccountDataUploadFile = async fileBuffer => {
  const workbook = new Excel.Workbook();
  await workbook.xlsx.load(fileBuffer);
  const worksheet = workbook.worksheets[0];
  const rows = [];

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === HEADER_ROW_INDEX) {
      return;
    }

    const rowValues = [...row.values];
    rowValues.shift();

    const mappedRow = zipObject(ACCOUNT_DATA_COLUMN_NAMES, rowValues);

    if (!isRowEmpty(mappedRow)) {
      rows.push({
        rowNumber,
        ...mappedRow,
      });
    }
  });

  return rows;
};
